"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
/* eslint-disable no-console */
var stopwatch_1 = __importDefault(require("../util/stopwatch"));
var Time = /** @class */ (function () {
    function Time() {
    }
    Object.defineProperty(Time, "stamp", {
        get: function () {
            var now = new Date();
            var secs = (now.getSeconds() + now.getMilliseconds() / 1000).toFixed(3);
            var diff = ((now.getTime() - Time.last.getTime()) / 1000).toFixed(3);
            Time.last = now;
            return {
                m: "".concat(now.getHours(), ":").concat(now.getMinutes(), ":").concat(secs),
                s: secs,
                d: diff,
                warn: Number(diff) > Time.threshold,
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.last = new Date();
    Time.threshold = 0.1;
    return Time;
}());
exports.Time = Time;
var _enablePerformanceLogging;
function enablePerformanceLogging() {
    if (typeof _enablePerformanceLogging === "undefined") {
        if (typeof window !== "undefined") {
            _enablePerformanceLogging = /[?&]perf=/i.test(window.location.search);
        }
    }
    return _enablePerformanceLogging;
}
function nWrapGetterTree(store, core) {
    return wrapGetterTree(store, core);
}
function wrapGetterTree(store, core) {
    if (!enablePerformanceLogging())
        return core;
    var wrapped = {};
    var _loop_1 = function (p) {
        wrapped[p] = function (state, getters, rootState, rootGetters) {
            var sw = new stopwatch_1.default();
            var r = core[p].apply(this, [state, getters, rootState, rootGetters]);
            var secs = sw.msraw();
            var ts = Time.stamp;
            var fn = ts.warn || secs > Time.threshold ? "warn" : "log";
            console[fn]("".concat(ts.s, " +").concat(ts.d, " ").concat(secs.toFixed(3), "s G ").concat(store, "/").concat(p), r);
            return r;
        };
    };
    for (var p in core) {
        _loop_1(p);
    }
    // console.log(`wrapGetterTree( ${store} )`, { core, wrapped });
    return wrapped;
}
function nWrapMutationTree(store, core) {
    return wrapMutationTree(store, core);
}
function wrapMutationTree(store, core) {
    if (!enablePerformanceLogging())
        return core;
    var wrapped = {};
    var _loop_2 = function (p) {
        wrapped[p] = function (state, payload) {
            var sw = new stopwatch_1.default();
            var r = core[p].apply(this, [state, payload]);
            var secs = sw.msraw();
            var ts = Time.stamp;
            var fn = ts.warn || secs > Time.threshold ? "warn" : "log";
            console[fn]("".concat(ts.s, " +").concat(ts.d, " ").concat(secs.toFixed(3), "s M ").concat(store, "/").concat(p), payload);
            return r;
        };
    };
    for (var p in core) {
        _loop_2(p);
    }
    // console.log(`wrapMutationTree( ${store} )`, { core, wrapped });
    return wrapped;
}
function isActionHandler(action) {
    return typeof action == "function";
}
var actionId = 1;
function nWrapActionTree(store, core) {
    return wrapActionTree(store, core);
}
function wrapActionTree(store, core) {
    if (!enablePerformanceLogging())
        return core;
    var wrapped = {};
    var _loop_3 = function (p) {
        var action = core[p];
        // @ts-ignore
        var actionHandler = isActionHandler(action) ? action : action.handler;
        var wrappedHandler = function (injectee, payload) {
            var sw = new stopwatch_1.default();
            var aid = actionId++;
            function report(m, result) {
                var secs = sw.msraw();
                var ss = m == "started" ? "" : "".concat(secs.toFixed(3), "s ");
                var ts = Time.stamp;
                var fn = ts.warn || secs > Time.threshold ? "warn" : "log";
                console[fn]("".concat(ts.s, " +").concat(ts.d, " ").concat(ss, "A #").concat(aid, " ").concat(m, " ").concat(store, "/").concat(p), {
                    payload: payload,
                    result: result,
                });
            }
            report("started", "started");
            var r = actionHandler.apply(this, [injectee, payload]);
            if (r && r.then) {
                var ts = Time.stamp;
                console.group("".concat(ts.s, " +").concat(ts.d, " A #").concat(aid, " async running ").concat(store, "/").concat(p));
                r.then(function (v) {
                    report("async", v);
                    console.groupEnd();
                });
            }
            else {
                report("sync", r);
            }
            return r;
        };
        if (isActionHandler(action)) {
            wrapped[p] = wrappedHandler;
        }
        else {
            // @ts-ignore
            wrapped[p] = __assign(__assign({}, action), { handler: wrappedHandler });
        }
    };
    for (var p in core) {
        _loop_3(p);
    }
    // console.log(`wrapActionTree( ${store} )`, { core, wrapped });
    return wrapped;
}
exports.default = {
    enablePerformanceLogging: enablePerformanceLogging,
    wrapGetterTree: wrapGetterTree,
    wrapMutationTree: wrapMutationTree,
    wrapActionTree: wrapActionTree,
    nWrapGetterTree: nWrapGetterTree,
    nWrapMutationTree: nWrapMutationTree,
    nWrapActionTree: nWrapActionTree,
};
//# sourceMappingURL=dev.performance.js.map